/* eslint-disable no-nested-ternary */
import React, { Fragment, useRef } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import { Popover, Spin } from 'antd';
import dayjs from 'dayjs';
import Helpers from '@Apis/helpers';
import './style.scss';

/**
 *
 */
function MetricInvAgeingSplit({
  data, loading, tenantIds, MONEY, user,
}) {
  const ref = useRef(null);
  const colors = [
    '#3f74e3',
    '#74d598',
    '#e8bb4a',
    '#67d0e8',
    '#7b76e5',
    '#a4de6c',
    '#f19941',
  ];

  const acceptedStockGrouping = data?.accepted_stock?.[0]?.ageing_range_grouping;
  return (
    <Fragment>
      <div className="metric-inv__expiry_split__wrapper">
        {loading && (
          <div className="widget-loader">
            <Spin />
          </div>
        )}
        <div className="metric-inv__ageing">
          <H3Text text="Stock Ageing" className="metric-inv__expiry_split__title" />
          <div className="ant-row">
            <div className="ant-col-md-24" ref={ref}>
              <div className="metric-inv__pie-wrapper">
                <div className="metric-inv__ageing-chart">
                  <div className="metric-inv__ageing-chart__labels">
                    {
                      acceptedStockGrouping?.map((item) => (
                        <H3Text text={item?.ageing_range} className="metric-inv__ageing-chart__label" />
                      ))
                    }
                  </div>
                  <div className="metric-inv__ageing-chart__bars">
                    {
                      acceptedStockGrouping?.map((item, index) => (
                        // eslint-disable-next-line react/jsx-key
                        <Popover
                          title={(
                            <div className="metric-inv__expiry_split__bar-info">
                              <H3Text text={MONEY(item?.stock_value || '0')} className="metric-inv__expiry_split__bar-info-value" />
                              <H3Text text={`${item?.batch_count} Batches of ${item?.item_count} Products`} className="metric-inv__expiry_split__bar-info-count" />
                              <div className="flex-display">
                                <H3Text text={item?.ageing_range} className="metric-inv__expiry_split__bar-info-text" />
                                <div style={{
                                  marginLeft: 'auto', textDecoration: 'underline', color: '#2d7cf7', fontSize: '11px',
                                }}
                                >
                                  <Link to={Helpers.appendSystemDefaultFilterIdInURL(`/inventory/manage?tab=/product-batches&page=1&limit=10&tenant=${tenantIds}&sortOrder=ASC&expiry_status=Good%20Stock&isRejectedBatch=false&startDate=${dayjs(new Date().toISOString()?.split('T')?.[0]).subtract((index + 1) * 30, 'days').valueOf()}&endDate=${dayjs(new Date().toISOString()?.split('T')?.[0]).subtract(index * 30, 'days').valueOf()}&department_id=${Helpers.getDepartmentId(user)}&quantity_class=POSITIVE_QUANTITY_BATCHES`)} target="_blank">view</Link>
                                </div>
                              </div>
                            </div>
                          )}
                        >
                          <div style={{ display: 'flex' }} className="metric-inv__ageing-chart__bar-wrapper">
                            <div className="metric-inv__ageing-chart__bar" style={{ width: `${(Number(item?.stock_value) / data?.accepted_stock?.[0]?.stock_value) * 100}%` }} />
                            <H3Text text={`${Number((Number(item?.stock_value) / data?.accepted_stock?.[0]?.stock_value) * 100)?.toFixed(2)}%`} className="metric-inv__ageing-chart__bar-text" />
                          </div>
                        </Popover>

                      ))
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({
});

MetricInvAgeingSplit.propTypes = {
  user: PropTypes.any,
  data: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MetricInvAgeingSplit));
